import API_ENDPOINTS from "../config/apiEndpoints";
import {requestWithAuth } from "./apiClient";

export const ApiSolicitudVacacionesService = {
  getAll: async (idEmpresa, desde, hasta, estado) => {
      let endpoint = API_ENDPOINTS.SOLICITUDES_AUSENCIA.ALL_EMPRESA(idEmpresa);
      const params = [];

      if (desde) params.push(`desde=${desde}`);
      if (hasta) params.push(`hasta=${hasta}`);
      if (estado) params.push(`estado=${estado}`);

      if (params.length > 0) {
          endpoint += `?${params.join('&')}`;
      }
    return requestWithAuth(endpoint, { method: "GET" });
  },
  deleteById: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.SOLICITUDES_AUSENCIA.DELETE(id), {
      method: "DELETE",
    });

    return response.json();
  },
  solicitar: async (idEmpresa, json) => {
    return requestWithAuth(API_ENDPOINTS.SOLICITUDES_AUSENCIA.CREATE(idEmpresa), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });
  },
  calcular: async (idEmpresa, json) => {
    const response = await requestWithAuth(API_ENDPOINTS.SOLICITUDES_AUSENCIA.CALCULAR(idEmpresa), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });
    return response.json();
  },
  getSolicitadasByEmpleadoId: async (idEmpleado, desde, hasta, estado) => {
      let endpoint = API_ENDPOINTS.SOLICITUDES_AUSENCIA.ALL_EMPLEADO(idEmpleado);
      const params = [];

      if (desde) params.push(`desde=${desde}`);
      if (hasta) params.push(`hasta=${hasta}`);
      if (estado) params.push(`estado=${estado}`);

      if (params.length > 0) {
          endpoint += `?${params.join('&')}`;
      }

    return requestWithAuth(endpoint, {
      method: "GET",
    });
  },
  getNotificacionesEmpresa: async (idEmpresa) => {
    return requestWithAuth(API_ENDPOINTS.SOLICITUDES_AUSENCIA.NOTIFCICACIONES(idEmpresa), {
      method: "GET",
    });
  },
  getPendientes: async (idEmpleado) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.SOLICITUDES.ALL_PENDIENTES(idEmpleado),
      { method: "GET" }
    );

    return response.json();
  },
  postTramitar: async (id, estado) => {
    return requestWithAuth(
      API_ENDPOINTS.SOLICITUDES_AUSENCIA.TRAMITAR(id),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(estado),
      }
    );
  },
};
